import React from 'react'
import createSvgIcon from './createSvgIcon'

export default createSvgIcon(
  <path
    d="M17 8C17 10.8 14.8 13 12 13C9.2 13 7 10.8 7 8C7 5.2 9.2 3 12 3C14.8 3 17 5.2 17 8ZM15 8C15 6.3 13.7 5 12 5C10.3 5 9 6.3 9 8C9 9.7 10.3 11 12 11C13.7 11 15 9.7 15 8ZM3 19C3 16.8 4.8 15 7 15H17C19.2 15 21 16.8 21 19V20C21 21.1 20.1 22 19 22H5C3.9 22 3 21.1 3 20V19ZM5 19V20H19V19C19 17.9 18.1 17 17 17H7C5.9 17 5 17.9 5 19Z"
    fill="currentColor"
  />,
  'People'
)
